import Commons from '../../Services/Common/Common';

export const M_ALL_BASIC_Schema = {
  mapper: {
    search1: {
      UserId: (context) => context.userInfo?.userid,
    },
    save1: {
      AlarmCd: (context) => Commons.EncryptAES(context.alarmCd),
      UserId: (context) => context.userInfo?.userid,
    },
    delete1: {
      AlarmCd: (row) => Commons.EncryptAES(row.alarmCd),
    },
  },
};
